import { BASE_API } from './index';
// const BASE_API = 'https://devyz.yunzhengshou.com/service';
/**
 * 预览Office文件
 * @param {*} url
 */
export function previewPageOffice(url) {
  const doc = document;
  // const body = doc.body;
  if (!url) {
    throw SyntaxError('Not provide required param URL');
  }
  url = BASE_API + url;
  const aid = 'view' + Math.random().toString(36).slice(2);
  const a = doc.createElement('a');
  const href = `javascript:POBrowser.openWindowModeless('` + url + `'` + `,'width=1200px;height=800px;');`;
  a.id = aid;
  a.style.width = '1px';
  a.style.height = '1px';
  a.style.position = 'absolute';
  a.href = href;
  // debugger;
  // a.target = '_blank';
  var evt = document.createEvent('MouseEvents');
  evt.initEvent('click', true, true);
  a.dispatchEvent(evt);
}



// WEBPACK FOOTER //
// ./src/untils/previewOffice.js